<template>
  <div class="ordertaskdetail">
     <div class="box">
      <div class="title">达人信息</div>
      <div class="content-table">
        <div>
          <div class="item-box">
            <label>昵称：</label>
            <div>{{ kol_user.nickname }}</div>
          </div>
          <div class="item-box">
            <label>平台：</label>
            <div>{{ kol_user.type_name }}</div>
          </div>
          <div class="item-box">
            <label>达人主页：</label>
            <div style="margin-top: -2px;">
              <el-popover
                v-if='!kol_user.home_link'
                placement="right"
                trigger="click"
                content="该达人主页还在完善哦">
                <el-link type="primary"
                  slot="reference"
                  :underline="false">查看达人主页</el-link>
              </el-popover>
              <el-link v-else
                type="primary"
                :underline="false" 
                :href='kol_user.home_link' 
                target='_blank'>查看达人主页</el-link>
            </div>
          </div>
          <!-- <div class="item-box">
            <label>达人号：</label>
            <div>{{ kol_user.id }}</div>
          </div> -->
          <div class="item-box">
            <label>粉丝数：</label>
            <div>{{ kol_user.fans }}</div>
          </div>
          <!-- <div class="item-box">
            <label>推荐理由：</label>
            <div style="margin-top: -2px;">
              <el-link type="primary"
                :underline="false" 
                @click="media_questions_obj.klurid = kol_user.klurid, 
                media_questions_obj.media_questions_flag = true">达人采访记录</el-link>
            </div>
          </div> -->
        </div>
        <div>
          <div class="item-box">
            <label>推广形式：</label>
            <div>
              <span class="sd-tag" v-if='cpx_deal.promote_video==2'>短视频</span>
              <span class="sd-tag" v-if='cpx_deal.promote_live==2'>直播混播</span>
              <span class="sd-tag" v-if='cpx_deal.promote_live_special==2'>直播专场</span>
              <span class="sd-tag" v-if='cpx_deal.promote_other==2'>其他</span>
            </div>
          </div>
          <!-- <div class="item-box">
            <label>媒介对接人：</label>
            <div>{{ kol_user.adid_name }}</div>
          </div>
          <div class="item-box">
            <label>运营对接人：</label>
            <div>{{ kol_user.operator_adid_name }}</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="box">
      <div class="title">商品列表</div>
      <div>
        <el-table :data="goodsList"
          :header-cell-style="{background: '#f9f9f9', color: '#333', fontSize: '14px', fontWeight: 'normal'}"
          :cell-style="{color:'#666', fontSize: '14px'}">
          <el-table-column label="基本信息" width="300">
            <template slot-scope="scope">
              <div class="flex">
                <img class="page-goods-img" :src="scope.row.goods_img" alt="商品图">
                <div>
                  <el-link
                    type="primary" 
                    :underline="false" 
                    :href="scope.row.goods_link" 
                    target="_blank">{{ scope.row.goods_name }}</el-link>
                  <div>商城：
                    <span v-if="scope.row.platform === 'taobao'">淘宝</span>
                    <span v-if="scope.row.platform === 'tianmao'">天猫</span>
                    <span v-if="scope.row.platform === 'jingdong'">京东</span>
                    <span v-if="scope.row.platform === 'suning'">苏宁</span>
                    <span v-if="scope.row.platform === 'kaola'">考拉</span>
                    <span v-if="scope.row.platform === 'douyin'">抖音小店</span>
                    <span v-if="scope.row.platform == 'weipinhui'">唯品会</span>
                    <span v-if="scope.row.platform == 'wangyiyanxuan'">网易严选</span>
                  </div>
                  <div>品牌：{{scope.row.brand_name}}</div>
                  <div>类目：{{scope.row.smzdm_category_1_name}}</div>
                  <div>商品ID：{{scope.row.goods_id}}</div>
                  <div>店铺：{{scope.row.store_name}}</div>
                  <div>日常售价：￥{{scope.row.daily_price}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="合作信息">
            <template slot-scope="scope">
              <!-- <div>是否团长合作：{{scope.row.is_head_coop === 1? '否':'是'}}</div> -->
              <div>可供样品数：{{scope.row.sample_number}}</div>
              <div>样品是否需要寄回：{{scope.row.is_retrieve_sample === 1? '否':'是'}}</div>
              <div>达人专属价：{{scope.row.kol_special_price}}元</div>
              <div>折扣方式：
                <span v-if="scope.row.discount_model==2">直降</span>
                <span v-if="scope.row.discount_model==3">满减</span>
                <span v-if="scope.row.discount_model==4">优惠券</span>
                <span v-if="scope.row.discount_model==5">优惠券+满减</span>
                <span v-if="scope.row.discount_model==4 || scope.row.discount_model==5">
                  (优惠券金额{{scope.row.coupon_money}}元 <span v-if="scope.row.discount_model==5 && scope.row.coupon_full">，</span>)</span>
                <span v-if="(scope.row.discount_model==3 || scope.row.discount_model==5) && scope.row.coupon_full">(满{{scope.row.coupon_full}}元减{{scope.row.coupon_subtract}}元)</span>
              </div>
              <div>佣金比例：{{scope.row.commission_rate}}%</div>
              <el-tooltip placement="top">
                <div slot="content" class="w-500">{{scope.row.specific_benefits}}</div>
                <div class="p-text-clamp">达人专属福利：{{scope.row.specific_benefits}}</div>
              </el-tooltip>
              <div>商单预计推广时间：</div>
              <div>{{cpx_order.expect_begin_time.slice(0,10)}} 至 {{cpx_order.expect_end_time.slice(0,10)}}</div>
              <!-- <div>团长类型：
                <span v-if="scope.row.article_head_type === 1">普通团长</span>
                <span v-if="scope.row.article_head_type === 2">内容团长</span>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="商品状态">
            <template slot-scope="scope">
              <div class="p-warning" v-if="scope.row.check_status==1">待审核</div>
              <div class="p-color-succ" v-if="scope.row.check_status==2">审核通过</div>
              <div class="p-color-danger" v-if="scope.row.check_status==3">审核不通过
                <el-tooltip placement="top">
                  <div slot="content" class="w-500">{{scope.row.refuse_reason}}</div>
                  <i class="p-color-danger el-icon-question"></i>
                </el-tooltip>
              </div>
              <div class="p-warning" v-if="scope.row.check_status==4">待分配</div>
              <div class="p-warning" v-if="scope.row.check_status==5">待回传</div>
              <div class="p-color-succ" v-if="scope.row.check_down==1">上架</div>
              <div class="p-color-danger" v-if="scope.row.check_down==2">下架
                <el-tooltip placement="top">
                  <div slot="content" class="w-500">{{scope.row.check_down_reason}}</div>
                  <i class="p-color-danger el-icon-question"></i>
                </el-tooltip>
              </div>
              <!-- <div>商品负责人：{{scope.row.cpx_goods_adid_name}}</div>
              <div>最近一次记录：
                <span v-if="scope.row.goods_change_history[0]">{{scope.row.goods_change_history[0].adid_name}} {{scope.row.goods_change_history[0].data_time}} {{scope.row.goods_change_history[0].new_info}}</span>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="带货任务状态">
            <template slot-scope="scope">
              <div>
                <span class="p-color-succ" v-if="scope.row.cpx_kol_user[0].check_status==0">进行中</span>
                <span class="p-color-succ" v-if="scope.row.cpx_kol_user[0].check_status==1">合作成功</span>
                <span class="p-color-danger" v-if="scope.row.cpx_kol_user[0].check_status==2">合作失败</span>
                <span class="p-warning" v-if="scope.row.cpx_kol_user[0].check_status==3">待审核</span>
                <span class="p-color-danger" v-if="scope.row.cpx_kol_user[0].check_status==4">待发货</span>
                <span class="p-color-danger" v-if="scope.row.cpx_kol_user[0].check_status==5">待收货</span>
                <span class="p-warning" v-if="scope.row.cpx_kol_user[0].check_status==6">待交付</span>
                <span class="p-warning" v-if="scope.row.cpx_kol_user[0].check_status==7">交付待确认</span>
                <el-tooltip placement="top" v-if="scope.row.cpx_kol_user[0].check_status==8">
                  <div slot="content" class="w-500">{{scope.row.reject_reason}}</div>
                  <div class="p-color-danger">已拒绝 <i class="el-icon-question p-color-danger"></i></div>
                </el-tooltip>
                <span class="p-color-danger" v-if="scope.row.cpx_kol_user[0].check_status==9">逾期</span>
                <span class="p-color-danger" v-if="scope.row.cpx_kol_user[0].check_status==10">已取消</span>
                <span class="p-warning" v-if="scope.row.cpx_kol_user[0].check_status==11">待填写寄样信息</span>
                <span class="p-warning" v-if="scope.row.cpx_kol_user[0].check_status==12">待效果回传</span>
              </div>
              <div>是否需要寄样：{{scope.row.cpx_kol_user[0].is_send_samples ==2 ? '否':'是'}}</div>
              <div>推广形式：
                <span class="sd-tag" v-if="scope.row.cpx_kol_user[0].promote_video==2">短视频</span>
                <span class="sd-tag" v-if="scope.row.cpx_kol_user[0].promote_live==2">直播混播</span>
                <span class="sd-tag" v-if="scope.row.cpx_kol_user[0].promote_live_special==2">直播专场</span>
                <span class="sd-tag" v-if="scope.row.cpx_kol_user[0].promote_other==2">其他(图文等)</span>
              </div>
              <!-- <div>带货任务创建人：{{scope.row.cpx_kol_user[0].kol_deal_adid_name}}</div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <div class="box">
      <div class="title">商单信息</div>
      <div class="content-table">
        <div>
          <div class="item-box">
            <label>商单标题：</label>
            <div>{{ cpx_order.cpx_order_name }}</div>
          </div>
          <div class="item-box">
            <label>报名截止时间：</label>
            <div>{{ cpx_order.sign_up_time }}</div>
          </div>
          <div class="item-box">
            <label>预计推广时间：</label>
            <div>{{ cpx_order.expect_begin_time }} 至 {{ cpx_order.expect_end_time }}</div>
          </div>
          <div class="item-box">
            <label>合作模式：</label>
            <div>
              <span class="sd-tag" v-if='cpx_order.cps==2'>CPS</span>
              <span class="sd-tag" v-if='cpx_order.cpt_goods==2'>CPT带货</span>
              <span class="sd-tag" v-if='cpx_order.cpt_recommended==2'>CPT种草</span>
              <span class="sd-tag" v-if='cpx_order.cpc==2'>CPC</span>
              <span class="sd-tag" v-if='cpx_order.cpa==2'>CPA</span>
            </div>
          </div>
          <div class="item-box">
            <label>推广形式：</label>
            <div>
              <span class="sd-tag" v-if="cpx_order.promote_video==2">短视频</span>
              <span class="sd-tag" v-if="cpx_order.promote_live==2">直播混播</span>
              <span class="sd-tag" v-if="cpx_order.promote_live_special==2">直播专场</span>
              <span class="sd-tag" v-if="cpx_order.promote_other==2">其他(图文等)</span>
            </div>
          </div>
          <div class="item-box">
            <label>预估帐期：</label>
            <div>{{ cpx_order.expect_payment }}</div>
          </div>
          <div class="item-box">
            <label>佣金价格负责人：</label>
            <div>{{ cpx_order.order_adid_name }}</div>
          </div>
          <div class="item-box">
            <label>项目负责人：</label>
            <div>{{ cpx_order.order_adid_name }}</div>
          </div>
          <div class="item-box">
            <label>项目运营负责人：</label>
            <div>{{ cpx_order.order_project_adid_name }}</div>
          </div>
          <div class="item-box">
            <label>项目媒介负责人：</label>
            <div>{{ cpx_order.cpx_project_kol_adid_name }}</div>
          </div>
          <div class="item-box">
            <label>项目其他干系人：</label>
            <div>
              <div v-for="(item, inx) in cpx_order.cpx_order_other" :key="inx+'ss'">
              {{item.project_adid_name}}（{{item.project_name}}）
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="q-mb15">1、客户品牌：{{ cpx_order.cpx_brand_name }}</div>
          <div class="q-mb15">2、客户来源：
            <span v-if="cpx_order.cpx_client_source == 1">品牌方</span>
            <span v-if="cpx_order.cpx_client_source == 2">TP代运营</span>
            <span v-if="cpx_order.cpx_client_source == 3">垂直代理</span>
            <span v-if="cpx_order.cpx_client_source == 4">广告公司</span>
            <span v-if="cpx_order.cpx_client_source == 5">广告公司</span>
            <span v-if="cpx_order.cpx_client_source == 6">其他</span>
          </div>
          <div class="q-mb15">3、投放落地到哪里：
            <span v-if="cpx_order.cpx_client_target_location_tb==2">淘宝</span>
            <span v-if="cpx_order.cpx_client_target_location_tm==2">天猫</span>
            <span v-if="cpx_order.cpx_client_target_location_jd==2">京东自营</span>
            <span v-if="cpx_order.cpx_client_target_location_jdpop==2">京东pop</span>
            <span v-if="cpx_order.cpx_client_target_location_other==2">其他 </span>
            <span>{{cpx_order.cpx_client_target_location_other_name}}</span>
          </div>
          <div class="q-mb15">4、全年GMV有多少，或问线上线下GMV占比多少？</div>
          <div class="q-mb15">
            <div>
              <span>GMV：</span>
              <div>{{cpx_order.cpx_client_yearly_GMV}}</div>
            </div>
            <div>
              <span>线上占比：{{cpx_order.cpx_client_yearly_GMV_online}}%</span>
              <span style="padding-left: 50px">线下占比：{{cpx_order.cpx_client_yearly_GMV_offline}}%</span>
            </div>
          </div>
          <div class="q-mb15">5、线上部分，天猫和京东的占比情况如何，分别怎么进行推广投放的？</div>
          <div class="q-mb15">{{ cpx_order.cpx_client_oneline_push_remark }}</div>
          <div class="q-mb15">6、电商平台是怎么做的？</div>
          <div class="q-mb15">{{ cpx_order.cpx_client_platform_push_remark }}</div>
          <div class="q-mb15">7、品牌找我们合作目的：GMV？ROI利润？品宣？</div>
          <div class="q-mb15">
            <div>第一选择：
              <span v-if="cpx_order.cpx_client_purpose_p == 1">GMV</span>
              <span v-if="cpx_order.cpx_client_purpose_p == 2">ROI（利润）</span>
              <span v-if="cpx_order.cpx_client_purpose_p == 3">品宣</span>
            </div>
            <div>第二选择：
              <span v-if="cpx_order.cpx_client_purpose_s == 1">GMV</span>
              <span v-if="cpx_order.cpx_client_purpose_s == 2">ROI（利润）</span>
              <span v-if="cpx_order.cpx_client_purpose_s == 3">品宣</span>
            </div>
          </div>
          <div class="q-mb15">8、样品管够吗，怎么发；佣金怎么开（定向/通用/营销、基础佣金够不够能不能挂上抖音快手）；坑位费给多少，以及开佣金改价格的对应负责人是谁？</div>
          <div class="q-mb15">
            <div>样品足量：
              <span v-if="cpx_order.cpx_client_sample == 1">是，管够</span>
              <span v-if="cpx_order.cpx_client_sample == 2">否，限量</span>
              <span v-if="cpx_order.cpx_client_sample == 3">无</span>
            </div>
            <div>佣金方式：
              <span v-if="cpx_order.cpx_client_commission_target==2">定向</span>
              <span v-if="cpx_order.cpx_client_commission_general==2">通用</span>
              <span v-if="cpx_order.cpx_client_commission_sale==2">营销</span>
              <span v-if="cpx_order.cpx_client_commission_other==2">其他</span>
              <span>{{cpx_order.cpx_client_commission_other_name}}</span>
            </div>
            <div>推广预算：￥{{cpx_order.budget_money}}</div>
            <div>佣金、价格负责人：{{cpx_order.cpx_client_commission_contact_name}}&nbsp;&nbsp;&nbsp;&nbsp;联系方式：{{cpx_order.cpx_client_commission_contact}}</div>
          </div>
          <div class="q-mb15">9、合同签好了吗？什么时候签，怎么签？是否已下发邮件？是否属于垫款池内客户</div>
          <div class="q-mb15">{{ cpx_order.cpx_client_contraction_remark }}</div>
          <div class="q-mb15">10、如果品牌特定达人，是否接受单次翻车可能</div>
          <div class="q-mb15">{{ cpx_order.cpx_client_other_remark }}</div>
        </div>
      </div>
    </div> -->
    <!-- 达人采访记录 -->
    <mediaquestions v-if="media_questions_obj.media_questions_flag" :media_questions_obj="media_questions_obj"></mediaquestions>
  </div>
</template>
<script>
import mediaquestions from "@/components/cpx/media_questions.vue"
export default {
  name:'ordertaskdetail',
  components:{
    mediaquestions
  },
  data(){
    return{
      media_questions_obj: {
        media_questions_flag: false,
        klurid: "",
      },
      cxdlid: "",
      cpx_deal:'',//当前待办
      cpx_order:'',//商单信息
      kol_user:'',//达人信息
      goodsList:[],
      apiUrl: {
        cpxDealInfo: "/home/cpxDealInfo",
        getCpxGoodsList: "/home/getCpxGoodsList"
      }
    }
  },
  created(){
      window.scrollTo(0,0)
      this.cxdlid = this.$route.query.cxdlid || ""
      this.getCpxDealInfo()
  },
  methods:{
    // 获取商单任务详情
    getCpxDealInfo(){
      this
        .$http({
          method: "GET",
          url: this.apiUrl.cpxDealInfo,
          params: {
            cxdlid: this.cxdlid,
          }
        })
        .then(res => {
          if (res.code == 1) {
            this.cpx_deal=res.data.cpx_deal//当前待办
            this.cpx_deal.rebate_proof_arr = res.data.cpx_deal.rebate_proof ? res.data.cpx_deal.rebate_proof.split(',') : []//当前待办
            if(res.data.cpx_order.cpx_brand_name.indexOf('其他品牌、') !=-1){
              res.data.cpx_order.cpx_brand_name = res.data.cpx_order.cpx_brand_name.replace("其他品牌、","其他品牌(") + ")"
            }
            this.cpx_order=res.data.cpx_order//商单信息
            this.kol_user=res.data.kol_user//达人信息
            this.getGoodsList()
          }else{
            this.$message.error(res.msg)
          }
        });
    },
    // 已选中商品列表
    getGoodsList(){
      let _this = this
      _this.$http({
        method: "POST",
        url: this.apiUrl.getCpxGoodsList,
        data: {
          klurid: _this.kol_user.klurid,
          cxorid: _this.cpx_deal.cxorid,
          is_cpx_kol_all: 2,
          limit: 100,
          offset: 1,
        }
      }).then(res => {
        if (res.code == 1) {
          let arr = res.data.list || []
          arr.forEach((item)=>{
            item.is_send_samples=0
          })
          _this.goodsList = arr
        }else{
          _this.$message.error(res.msg)
        } 
      });
    },
    //商品页面
    goGoodsinfo(url) {
      window.open(url, "_blank");
    }
  }
}
</script>
<style scoped>
.ordertaskdetail .box {
  margin-bottom: 20px;
}
.title {
  font-size: 20px;
  color: #252328;
  margin-bottom: 20px;
  position: relative;
}
.title::before {
  content: "";
  position: absolute;
  width: 3px;
  height: 20px;
  background-color: #6435E8;
  left: -20px;
  top: 4px;
}
.content-table {
  display: flex;
  font-size: 14px;
  color: #666;
}
.content-table > div {
  flex: 1;
  text-align: left;
}
.img-box {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  margin-left: -5px;
}
.item-box {
  display: flex;
  line-height: 28px;
  /* margin-bottom: 10px; */
}
.item-box > label {
  width: 140px;
  text-align: right;
}
.item-box > div {
  width: 315px;
  word-break: break-all;
}
.q-mb15 {
  line-height: 28px;
  /* margin-bottom: 10px; */
}
.p-text-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.w-500 {
  max-width: 500px;
}
</style>